import type { Theme } from '@mui/material/styles';

export const usePasswordStrengthStyle = (theme: Theme) => ({
  root: {
    mt: 1,
    mb: 1,
    // Match the width of the password field above it, without making that
    // field's container wider when the text is longer than the field.
    width: 0,
    minWidth: '100%',
  },
  bar: {
    height: 6,
    borderRadius: 3,
    mb: 1,
    backgroundColor: theme.palette.grey[300],
  },
  list: {
    listStyle: 'none',
    m: 0,
    mt: 1,
    p: 0,
  },
  listInline: {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: 2,
    mt: 0,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.75,
    py: 0.25,
  },
  icon: {
    fontSize: 16,
  },
  warning: {
    mt: 0.5,
    color: theme.palette.warning.dark,
  },
});
